<template>
	<div class="quad__block__child image">
		<img class="single__image" :src="single_image" alt="poster" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			hello: 'World',
		};
	},

	props: {
		single_image: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/variables";

.image {
	background-color: #212121;
	min-width: 100px;
	min-height: 100px;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;

	&:hover {
		img.single__image {
			transform: scale(1.1);
		}
	}

	img {
		&.single__image {
			object-fit: cover;
			width: 100%;
			height: 100%;
			transition: 0.2s ease all;
			transform: scale(1);
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SingleImage.vue